"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../../lib");
/**
 * NavLink component
 *
 * @visibleName NavLink
 */
const NavLinkComponent = (props) => {
    const { children, className, as, to } = props;
    const Element = (0, lib_1.getElementType)(NavLinkComponent, props);
    const navOption = {};
    if (as === "a") {
        navOption["href"] = to;
    }
    else {
        navOption["to"] = to;
    }
    return ((0, jsx_runtime_1.jsx)(Element, Object.assign({}, navOption, { className: (0, lib_1.classnames)(className, (0, lib_1.bem)("nav__link")) }, { children: children }), void 0));
};
NavLinkComponent.defaultProps = {
    as: "a",
};
exports.NavLink = NavLinkComponent;
//# sourceMappingURL=NavLink.js.map